import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/35.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Żylasty gęsiarz potrzebuje pomocy"
            question="chcesz pomóc gęsiarzowi Stefanowi?"
            audio={audio}
            answers={{
                ans1: "Trzeba mu pomóc.",
                ans2: "Niech radzi sobie sam!",
            }}
            links={{
                link1: PAGES.p62,
                link2: PAGES.p63,
            }}
            content={
                <div>
                    <ul>
                        <li>Macie koryto? – zza domu wybiega żylasty gęsiarz. Nietrudno go rozpoznać, to ten sam, co drwił sobie z ciebie wczoraj.</li>
                        <li>Właśnie mówiłem, że pożyczyłem, a co? – odpowiada Emil.</li>
                        <li>Jak to co? Targ! Święto dyszla! Płynąć, gęsi sprzedawać, dzień targowy święcić! Do Zagórowa, gęsi...!</li>
                        <li>Co jest, Stefan, swojej łódki nie masz? – pyta Emil.</li>
                        <li>Kaprawa jest, dziurawa… Nie popłynę! Pomóżcie!</li>
                        <li>A kolegów nie masz? Wreszcie się na tobie poznali… – Emil chyba też nie przepada za humorem gęsiarza Stefana.</li>
                        <li>Popłynęli, no! Nikogo już nie ma!</li>
                    </ul>
                    <p>
                        Kiedy Emil rozmawia ze Stefanem, przypomina ci się stary Tornau, który trzyma gęsi na wyspie. Ale czy na pewno chcesz pomóc gęsiarzowi Stefanowi?
                    </p>
                </div>
            }
        />

    );
}